import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  PaymentDashboardStateType,
  PaymentChannelType,
  SetQueryPayloadActionType,
  PaymentListType,
} from 'features/Payment/@types/paymentDashboard'

export const SLICE_NAME = 'paymentDashboard'

export const initialState: PaymentDashboardStateType = {
  isLoading: [],
  paymentChannel: [],
  paymentList: [],
  selectedPaymentChannel: null,
  query: {
    page: 1,
    limit: 20,
    orderChildID: '',
    status: { name: '', value: '' },
    start_date: undefined,
    end_date: undefined,
    next_cursor: '',
    prev_cursor: '',
    cursor: '',
  },
}

const paymentGatewayAdmin = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      if (payload) {
        state.isLoading.push(true)
      } else {
        state.isLoading.pop()
      }
    },
    setQuery: (state, { payload }: PayloadAction<SetQueryPayloadActionType>) => {
      const { value } = payload

      state.query = { ...state.query, ...value }
    },
    setPaymentChannel: (state, { payload }: PayloadAction<PaymentChannelType[]>) => {
      state.paymentChannel = payload
    },
    setSelectedPaymentChannel: (
      state,
      { payload }: PayloadAction<Nullable<PaymentChannelType>>,
    ) => {
      state.selectedPaymentChannel = payload
    },
    setPaymentList: (state, { payload }: PayloadAction<PaymentListType[]>) => {
      state.paymentList = payload
    },
  },
})

export default paymentGatewayAdmin.reducer
export const {
  reset,
  setSelectedPaymentChannel,
  setQuery,
  setPaymentChannel,
  setIsLoading,
  setPaymentList,
} = paymentGatewayAdmin.actions
